// extracted by mini-css-extract-plugin
export default {"container":"athleteCard_container__fPTmQ","active-athlete":"athleteCard_active-athlete__rGsI1"};